import { Button } from "@telluscompany/design-system";

import { useLocalization } from "@i18n";

import type { ListAdminStructuresResponseItem } from "../../api/structures";

type AdminStructuresDetailsActionProps = {
  rowData: ListAdminStructuresResponseItem;
  onDetails: (structure: ListAdminStructuresResponseItem) => void;
};

/** Botão Detalhes por linha (PRD §3 — sem menu ⋮). */
export const AdminStructuresDetailsAction = ({
  rowData,
  onDetails,
}: AdminStructuresDetailsActionProps) => {
  const { translate } = useLocalization();

  return (
    <Button
      type="button"
      size="small"
      variant="secondary"
      className="whitespace-nowrap"
      data-testid={`structure-details-btn-${rowData.id}`}
      onClick={(event) => {
        event.stopPropagation();
        onDetails(rowData);
      }}
    >
      {translate("admin.structures.table.action.details")}
    </Button>
  );
};
